export enum Scope {
  PRIVATE = 'private',
  PUBLIC = 'public',
  PUBLIC_EDITABLE = 'public-editable',
  HIDDEN = 'hidden',
  SNAPSHOT = 'snapshot',
  SYSTEM_GENERATED = 'SYSTEM_GENERATED',
}
